import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import BMXAsynchronous from "../../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";

const DeviceOtherModalStepOne = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { values, form } = props;

  const [priceLists, setPriceLists] = useState([]);

  // Funkcja do pobierania PriceList z API
  const getPriceLists = async (searchTerm) => {
    if (!searchTerm || searchTerm.length === 0) return [];

    try {
      const response = await GlobalAuthFetch({
        path: `/pricelist/search?query=${encodeURIComponent(searchTerm)}`,
      });

      const priceListPayload = response?.payload?.data || [];

      const formatted = priceListPayload.map((pl) => ({
        uuid: pl.uuid,
        name: pl.index, // identyfikator
        value: pl.index, // to, co będzie wyświetlane w polu
        ...pl,
      }));

      setPriceLists(formatted);
      return formatted;
    } catch (error) {
      console.error("Error fetching price lists:", error);
      setPriceLists([]);
      return [];
    }
  };

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col xs={12}>
          <Field
            currentValues={values}
            className="priceList"
            component={BMXAsynchronous}
            getOptionLabel={(option) => {
              if (option.name) return option.name;
              return option;
            }}
            label={`${t("global:device.otherBid")}*`}
            name="priceList"
            options={priceLists}
            getData={getPriceLists}
            data-cy="priceList"
            disablePortal={true}
            onClose={() => {}}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DeviceOtherModalStepOne;
